'use client';
import React, { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { SectionHeader } from '@/components/ui/Typography';

export default function VendorProvenExpert() {
  const t = useTranslations('vendor_page');

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://www.provenexpert.com/widget/landing_4takeaway.js?feedback=1&avatar=1&competence=1&style=white';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="container">
      <div className="flex flex-col items-center justify-center space-y-2 pb-16">
        <div className="text-base font-normal text-primary">
          {t('proven_expert.top_header')}
        </div>
        <SectionHeader>{t('proven_expert.header')}</SectionHeader>
        {/* <h3 className="text-center text-h1 font-[900] text-title">
        </h3> */}
        <h3 className="text-lg text-paragraph text-opacity-70">
          {t('proven_expert.bottom_header')}
        </h3>
      </div>
      <div id="pewl"></div>
      <link
        rel="stylesheet"
        type="text/css"
        href="https://www.provenexpert.com/css/widget_landing.css"
        media="screen,print"
      ></link>
    </div>
  );
}
